// 深拷贝
const deepClone = sourceObj => {
  if (!sourceObj || typeof sourceObj !== 'object' || Object.keys(sourceObj).length === undefined) {
    return sourceObj;
  }
  const cloneObj = sourceObj instanceof Array ? [] : {};
  Object.keys(sourceObj).forEach(obj => {
    cloneObj[obj] = deepClone(sourceObj[obj]);
  });
  return cloneObj;
}

export default deepClone;